<template>
  <div class="iframeContent">
    <div class="iframe-container">
      <iframe
        ref="myIframe"
        :src="iframeSrc"
        frameborder="0"
        allow="camera *; microphone *; display-capture *; fullscreen *; clipboard-read *; clipboard-write *; autoplay *"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals" />
    </div>
  </div>
</template>

<script>
import { getInfo } from '../api/user';
export default {
  name: 'Home',
  data() {
    return {
      userType: '',
      iframeSrc: '',
    };
  },
  components: {},
  created() {},
  watch: {},
  mounted() {
    this.getUserInfo();
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      console.log('addEventListener', event);
      if (event.data && event.data.type === 'logout') {
        console.log('handleMessage', event);
        localStorage.clear();
        window.location.href = process.env.VUE_APP_LOGOUT_URL;
      }
    },
    async getUserInfo() {
      await getInfo().then((res) => {
        localStorage.setItem('userInfo', JSON.stringify(res));
        console.log('process.env',process.env);
        
        this.userType = res.user.userType;
        if (this.userType == '02') {
          // 学生
          this.iframeSrc = process.env.VUE_APP_SSO_QQ_HOME_PAGE + 'student%2FstudentHome';
        } else {
          this.iframeSrc = process.env.VUE_APP_SSO_QQ_HOME_PAGE + 'teacher%2Fhome';
        }
        let url = window.location.search;
        const urlObj = new URLSearchParams(url);
        const code = urlObj.get('code');
        const appid = urlObj.get('appid');
        if (!appid && code) {
          window.location.href = process.env.VUE_APP_SSO_QQ_URL + `${code}`;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.iframeContent {
  width: 100vw;
  height: 100vh;
  .iframe-container {
    width: 100%;
    height: 100%;
  }
  .iframe-container iframe {
    width: 100%;
    height: 99.6%;
    border: none;
  }
}
</style>
